import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AppSettingsService {

  headers: any;
  error: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };
  private configuration: any;


  constructor(
    private httpClient: HttpClient,
  ) { }

  // init() {
  //   return new Promise<boolean>((resolve, reject) => {
  //     this.httpClient.get('api/appSettings', this.httpOptions).pipe(map(res => res))
  //       .subscribe(value => {
  //         this.configuration = value;
  //         resolve(true);
  //       },
  //         (error) => {
  //           reject(error);
  //         });
  //   });
  // }

  getAppSettings() {
    return this.httpClient.get('api/appSettings', this.httpOptions);
  }

  // getAppSettingByName(settingName: string) {
  //   return this.httpClient.get('api/appSettings/ByName/' + settingName, this.httpOptions);
  // }

  getSettingByName(settingName: string) {
    return this.configuration[settingName];
  }
}
